import { render, staticRenderFns } from "./submissions-select-form.vue?vue&type=template&id=7089cf90&scoped=true&"
import script from "./submissions-select-form.vue?vue&type=script&lang=js&"
export * from "./submissions-select-form.vue?vue&type=script&lang=js&"
import style0 from "./submissions-select-form.vue?vue&type=style&index=0&id=7089cf90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089cf90",
  null
  
)

export default component.exports